/*
 * @Author: your name
 * @Date: 2020-04-23 17:57:27
 * @LastEditTime: 2021-05-25 14:49:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\main.ts
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import * as FastClick from 'fastclick';
import { MessageBox as MessageBoxPC,Col,Row  } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Toast,Navbar, TabItem ,TabContainer, TabContainerItem,Actionsheet,MessageBox} from 'mint-ui';



Vue.config.productionTip = false;
(FastClick as any).attach(document.body);
Vue.component(MessageBoxPC.name, MessageBoxPC )
Vue.component(MessageBox.name, MessageBox )
Vue.component(Toast.name, Toast )
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(Actionsheet.name, Actionsheet);
Vue.component(Col.name, Col);
Vue.component(Row.name, Row);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
